import { render, staticRenderFns } from "./PageHero.vue?vue&type=template&id=88c43cca&"
import script from "./PageHero.vue?vue&type=script&lang=js&"
export * from "./PageHero.vue?vue&type=script&lang=js&"
import style0 from "./PageHero.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports